module.exports = __webpack_public_path__ + "static/felt-7abd7711802c2b2e873d45128d89dc9f.png";